module.exports = __webpack_public_path__ + "img/spin_btn.343bda50.png";